import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getBaseExperts: analyticsTypes.GetBaseExperts = (params) => {
  return axios.get(`/analytics/base/experts`, { params });
};

type QueryFnType = typeof getBaseExperts;

type UseGetBaseExperts = {
  region?: 'cis' | 'la';
  config?: QueryConfig<QueryFnType>;
};

export const useGetBaseExperts = ({ config = {}, region }: UseGetBaseExperts = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['analytics-base-experts', region],
    queryFn: () => getBaseExperts(region ? { region } : undefined),
  });
};
